// extracted by mini-css-extract-plugin
module.exports = {"warn":"styles_warn__3Ldd_"};